import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "note-fields -pxy_0" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "notes-footer" }

import { computed } from 'vue'

import { NOTE_TITLE_MAX_LENGTH } from '@/scripts/app-configs/constants'
import useSwordForm from '@/composables/useSwordForm'
import { baseNoteSchema } from '@/utils/zod/schemas/patient/member-notes'


export default /*@__PURE__*/_defineComponent({
  __name: 'EditNoteForm',
  props: {
    titleValue: { default: '' },
    bodyValue: { default: '' }
  },
  emits: ["title", "body", "submit-form", "cancel", "new-note"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const title = computed({
  get: () => props.titleValue,
  set: (value) => emit('title', value),
})

const body = computed({
  get: () => {
    const parser = new DOMParser()
    const dom = parser.parseFromString(props.bodyValue, 'text/html')

    return dom.body.textContent
  },
  set: (value) => emit('body', value),
})

const formState = computed(() => ({
  title: title.value,
  body: body.value,
}))

const { $v } = useSwordForm({ validationSchema: baseNoteSchema, formState })

const submitForm = () => emit('submit-form')

return (_ctx: any,_cache: any) => {
  const _component_base_input_wuk = _resolveComponent("base-input-wuk")!
  const _component_input_error_wuk = _resolveComponent("input-error-wuk")!
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!

  return (_openBlock(), _createElementBlock("form", {
    class: "note-form-wrapper",
    name: "noteEdition",
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (submitForm()), ["prevent"]))
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_base_input_wuk, {
        modelValue: title.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
        class: "-pxy_2",
        name: "noteTitle",
        placeholder: _ctx.$t('NOTES.TITLE'),
        maxlength: _unref(NOTE_TITLE_MAX_LENGTH),
        validation: _unref($v).title
      }, null, 8, ["modelValue", "placeholder", "maxlength", "validation"]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body).value = $event)),
        class: "note-body sword-base-input-wuk -pt_0 -px_2 -pb_1",
        name: "noteBody",
        placeholder: _ctx.$tc('copy_2829'),
        autocomplete: "off",
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_unref($v).body.$reset())),
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref($v).body.$touch()))
      }, null, 40, _hoisted_2), [
        [_vModelText, body.value]
      ]),
      (_unref($v).body.$invalid)
        ? (_openBlock(), _createBlock(_component_input_error_wuk, {
            key: 0,
            class: "note-error-feedback -pxy_2",
            validator: _unref($v).body
          }, null, 8, ["validator"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_sword_button_wuk, {
        text: "COMMON.CANCEL",
        icon: "close",
        side: "left",
        class: "cancel-button",
        onClickNative: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel')))
      }),
      _createVNode(_component_sword_button_wuk, {
        text: "copy_2684",
        icon: "add",
        side: "left",
        type: "submit",
        disabled: _unref($v).$invalid,
        onClickNative: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('new-note')))
      }, null, 8, ["disabled"])
    ])
  ], 32))
}
}

})